import { http } from '@beelday/common'
import { Config } from 'common/config'
import { RoomAddress } from 'common/types'
import { useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'

export type ParamTogglerApi = {
	toggleOnParam: (address: RoomAddress, param: string) => Promise<void>
	toggleOffParam: (address: RoomAddress, param: string) => Promise<void>
}

export const createParamTogglerApi = (serverUrl: string): ParamTogglerApi => ({
	toggleOnParam: (address: RoomAddress, param: string) =>
		fetch(
			`${serverUrl}/api/v0/workflows/${address.workflowId}/interactionschemes/${address.interactionSchemeId}/rooms/${address.roomId}/features/change/paramtoggler/${param}`,
			{
				method: 'POST',
				headers: {
					'PB-Correlation-Id': uuidv4().replaceAll('-', '').slice(0, 16),
					'Content-Type': 'application/json',
				},
			}
		).then(http.checkStatus),
	toggleOffParam: (address: RoomAddress, param: string) =>
		fetch(
			`${serverUrl}/api/v0/workflows/${address.workflowId}/interactionschemes/${address.interactionSchemeId}/rooms/${address.roomId}/features/clear/paramtoggler/${param}`,
			{
				method: 'DELETE',
				headers: {
					'PB-Correlation-Id': uuidv4().replaceAll('-', '').slice(0, 16),
					'Content-Type': 'application/json',
				},
			}
		).then(http.checkStatus),
})

export const useParamTogglerApi = (): ParamTogglerApi => {
	return useMemo(() => createParamTogglerApi(Config.beeldayBackendUrl), [])
}

export default useParamTogglerApi
